export const _ADD               = "i2Lckt9d4kuiztVk7QVyEg==";
export const _EDIT              = "eGZ5LV9Sk5AlTHc2/3i2Hw==";
export const _VIEW              = "a3ZbwMxhRbvaMD2Rt5bcVw==";
export const _DELETE            = "TYwcJV1jDAytm1YKW/RvbQ==";
export const _RECOVER           = "cBaWcOb5ttDRj3+NXJni3A==";
export const _LIST              = "zGJkzqCmX02bIY5rX7Y37A==";
export const _TRASH             = "2I++Hpg3Wn3iFEOZDFASFw==";